import 'babel-polyfill'

import SwHic, { Vue } from "sw-hic";
import "sw-hic/sw-hic.css"
import SwHicMasterdata from "sw-hic-masterdata"
import x2js from "x2js"
import myComponents from '../packages/index'
import store from '@/common/store'
import router from '@/common/router'
import api from '@/common/api'
import App from "./App"

Vue.config.productionTip = false


if (process.env.NODE_ENV == 'development') {
  // 引入mockjs
  // require('./common/mock.js')
}

Vue.prototype.$editor = new NsoOffice()
Vue.prototype.$x2js = new x2js()
Vue.prototype.$cfg = cfg
Vue.prototype.$bus = new Vue()

Vue.use(SwHic)
Vue.use(SwHicMasterdata)
Vue.use(myComponents)
Vue.prototype.$api = api

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
